import * as React from 'react'
import { HoverCard,HoverCardContent,HoverCardTrigger } from '@/components/ui/hover-card'
import { Button } from '@/components/ui/button'
import { ImageWithSkeleton } from '@/components/ui/image-with-skeleton'
import { Link } from '@tanstack/react-router'
import type { Brand } from '@/types'
import { cn } from '@/lib/utils'

interface BrandHoverCardProps {
  brand: Brand
  triggerClassName?: string
}

export function BrandHoverCard({ brand, triggerClassName }: BrandHoverCardProps) {
  const brandLogo = brand.logo || brand.image || (brand.images && brand.images.length > 0 ? brand.images[0] : null)

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <span className={cn("cursor-help hover:underline decoration-dotted underline-offset-4 decoration-muted-foreground/50", triggerClassName)}>
          {brand.name}
        </span>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <div className="flex flex-col gap-3">
          <div className="flex justify-between space-x-4">
            <div className="space-y-1">
              <h4 className="text-sm font-semibold">{brand.name}</h4>
              {(brand.description || brand.details) && (
                <p className="text-sm text-muted-foreground line-clamp-3">
                  {brand.description || brand.details}
                </p>
              )}
              {brand.website && (
                <div className="flex items-center pt-1">
                  <a
                    href={brand.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-primary hover:underline flex items-center"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Visit Website
                  </a>
                </div>
              )}
            </div>
            {brandLogo && (
              <div className="shrink-0">
                <div className="h-10 w-10 rounded-md border bg-muted/50 overflow-hidden">
                  <ImageWithSkeleton
                    src={brandLogo as string}
                    alt={brand.name}
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
            )}
          </div>
          <Button variant="outline" size="sm" className="w-fit h-7 text-xs px-3" asChild>
            <Link to="/catalog/brands/$item" params={{ item: brand.id }} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              View Brand
            </Link>
          </Button>
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}
